import { IconSvg } from '@graphcommerce/next-ui'
import CustomCartIconSvg from './CustomCartIcon.svg'

export function CustomCartIcon() {
  return <IconSvg src={CustomCartIconSvg} size='large' />
}
